import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import {
  ActionDialogBodyWithTextInput,
  ActionDialogBodyWithTextInputProps,
  ActionDialogBodyWithTextInputState,
} from '~src/commonInfra/dialogs/ActionDialogBodyWithTextInput';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { callUpdateDatasourceRevisionMetadata } from '~src/revisionHistoryDatasource/serverApi/requests/UpdateDatasourceRevisionMetadataRequest';
import { IDatasourceRevision } from '~src/revisionHistoryDatasource/serverApi/types/IDatasourceRevision';
import { callUpdateWorkbookRevisionMetadata } from '~src/revisionHistoryWorkbook/serverApi/requests/UpdateWorkbookRevisionMetadata';
import { IWorkbookRevision } from '~src/revisionHistoryWorkbook/serverApi/types/IWorkbookRevision';

import { RevisionHistoryActionContext } from '../interfaces/RevisionHistoryActionContext';

const MAX_NOTES_LENGTH = 2000;

export namespace UpdateRevisionNotesAction {
  export function showUpdateWorkbookRevisionNotesDialog(
    revision: IWorkbookRevision,
    context: RevisionHistoryActionContext<any>
  ): void {
    openReactActionDialog<ActionDialogBodyWithTextInputProps, ActionDialogBodyWithTextInputState, void>({
      title: Messages.revisionNotesDialogTitle(),
      bodyComponent: ActionDialogBodyWithTextInput,
      initialBodyProps: {
        originalText: revision.notes || '',
        label: Messages.revisionNotesLabel(),
        maxLength: MAX_NOTES_LENGTH,
      },
      initialDialogState: { text: revision.notes || '' },
      actionName: Messages.revisionNotesSubmitButton(),
      action: (_props, state) => {
        return callUpdateWorkbookRevisionMetadata(context.contentLuid, revision.versionNumber, state.text)
          .then(() => {
            ToasterService.instance.pop({ type: ToastType.Info, text: Messages.revisionNotesUpdateSuccess() });
          })
          .catch(() => {
            ToasterService.instance.pop({ type: ToastType.Error, text: Messages.revisionNotesUpdateError() });
            return Promise.reject();
          });
      },
      dismissDialogOnActionFailed: false,
      dialogWidth: TabDialogWidth.width500px,
    });
  }

  export function showUpdateDatasourceRevisionNotesDialog(
    revision: IDatasourceRevision,
    context: RevisionHistoryActionContext<any>
  ): void {
    openReactActionDialog<ActionDialogBodyWithTextInputProps, ActionDialogBodyWithTextInputState, void>({
      title: Messages.revisionNotesDialogTitle(),
      bodyComponent: ActionDialogBodyWithTextInput,
      initialBodyProps: {
        originalText: revision.notes || '',
        label: Messages.revisionNotesLabel(),
        maxLength: MAX_NOTES_LENGTH,
      },
      initialDialogState: { text: revision.notes || '' },
      actionName: Messages.revisionNotesSubmitButton(),
      action: (_props, state) => {
        return callUpdateDatasourceRevisionMetadata(context.contentLuid, revision.versionNumber, state.text)
          .then(() => {
            ToasterService.instance.pop({ type: ToastType.Info, text: Messages.revisionNotesUpdateSuccess() });
          })
          .catch(() => {
            ToasterService.instance.pop({ type: ToastType.Error, text: Messages.revisionNotesUpdateError() });
            return Promise.reject();
          });
      },
      dismissDialogOnActionFailed: false,
      dialogWidth: TabDialogWidth.width500px,
    });
  }
}
